import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../origami-logo.jpg';
import LoginAvatar from '../LoginAvatar';
import CartIcon from '../Cart/CartIcon';
import CartDrawer from '../Cart/CartDrawer';
import './TopBar.css';

function TopBar() {
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <header className="topbar">
      <div className="topbar__inner">
        <Link to="/" className="topbar__brand" aria-label="Origami home">
          <img src={logo} alt="Origami logo" className="topbar__logo" />
        </Link>
        
        <div className="topbar__nav">
          <Link to="/marketplace" className="topbar__marketplace-btn">
            Marketplace
          </Link>
          <Link to="/library" className="topbar__cta">
            My Library
          </Link>
          <Link to="/contact" className="topbar__cta">
            Contact
          </Link>
          <CartIcon onClick={() => setCartOpen(true)} />
          <div className="topbar__avatar">
            <LoginAvatar variant="inline" />
          </div>
        </div>
      </div>

      <CartDrawer isOpen={cartOpen} onClose={() => setCartOpen(false)} />
    </header>
  );
}

export default TopBar;
